import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;
const { colors: dsColors } = themeVariables;

export const main = css`
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1070px;
  padding: ${spacing.md}px ${spacing.md}px ${spacing.xxl}px;
  width: 100%;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding-left: ${spacing.sm}px;
      padding-right: ${spacing.sm}px;
    `,
  )}
`;

export const pageTitle = css`
  color: var(${dsColors.content.primary});
  font-weight: 600;
  margin: 0 0 ${spacing.md}px;
  ${theme.responsiveText.HEADING.LG}
`;

export const section = css`
  margin-bottom: ${spacing.lg}px;
`;

export const sectionTitle = css`
  color: var(${dsColors.content.primary});
  margin: 0 0 ${spacing.sm}px;

  a {
    ${theme.responsiveText.HEADING.XS}
    color: inherit;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

/** Multi-column link grid (compact, like browse PLP sitemap). */
export const linkGrid = css`
  display: grid;
  gap: ${spacing.xs}px ${spacing.xl}px;
  grid-template-columns: 1fr;
  list-style: none;
  margin: 0;
  padding: 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-template-columns: repeat(2, 1fr);
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-template-columns: repeat(3, 1fr);
      gap: ${spacing.xs}px ${spacing.xxl}px;
    `,
  )}
`;

export const linkGridItem = css`
  line-height: 1.35;
  margin: 0;

  a {
    ${theme.responsiveText.BODY.MD}
    color: var(${dsColors.content.link});
    display: inline;
    text-decoration: underline;
    word-break: break-word;

    &:hover {
      text-decoration: none;
    }
  }
`;
